<script>
export default {
  name: 'ResetGrid',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <VChip
    :disabled="loading"
    variant="outlined"
    class="ml-4 reset-grid__button"
    tag="button"
    @click="$emit('reset')"
  >
    <VIcon
      size="small"
      start
    >
      $close
    </VIcon>
    Reset
  </VChip>
</template>

<style lang="scss">
.reset-grid {
  &__button.v-chip .v-icon {
    color: rgb(var(--v-theme-grey-darken-2));
  }

  &__button {
    border-color: rgb(var(--v-theme-grey-lighten-2));
    min-width: fit-content;
  }
}
</style>
